import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

import { JSX } from 'react';
import styles from './borrowMore.module.scss';
import { BorrowMoreInner } from './parts';

export type BorrowMoreProps = SliceComponentProps<Content.BorrowMoreSlice>;

const BorrowMore = ({ slice }: BorrowMoreProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
      className={styles[slice.variation]}
    >
      <BorrowMoreInner slice={slice} />
    </section>
  );
};

export default BorrowMore;
